let burger = document.getElementById('burger'),
    nav = document.getElementById('main-nav'),
    nav__link1 = document.getElementById('nav__link1'),
    nav__link2 = document.getElementById('nav__link2'),
    nav__link3 = document.getElementById('nav__link3'),
    nav__link4 = document.getElementById('nav__link4'),
    nav__link5 = document.getElementById('nav__link5');

burger.addEventListener('click', function(e) {
    this.classList.toggle('is-open');
    nav.classList.toggle('is-open');
});
nav__link1.addEventListener('click', function(e) {
    burger.classList.toggle('is-open');
    nav.classList.toggle('is-open');
});
nav__link2.addEventListener('click', function(e) {
    burger.classList.toggle('is-open');
    nav.classList.toggle('is-open');
});
nav__link3.addEventListener('click', function(e) {
    burger.classList.toggle('is-open');
    nav.classList.toggle('is-open');
});
nav__link4.addEventListener('click', function(e) {
    burger.classList.toggle('is-open');
    nav.classList.toggle('is-open');
});
nav__link5.addEventListener('click', function(e) {
    burger.classList.toggle('is-open');
    nav.classList.toggle('is-open');
});

function magic() {
	if (window.pageYOffset > 200) {
        $(".top-btn").addClass("top-btn--scroll");
        $(".header").addClass("header--scroll");
        $(".nav__btn--login").addClass("nav__btn--scroll");
	} else {
        $(".top-btn").removeClass("top-btn--scroll");
        $(".header").removeClass("header--scroll");
        $(".nav__btn--login").removeClass("nav__btn--scroll");
	}
}
document.querySelector('.top-btn').onclick = function () {
	window.scrollTo(0, 0)
}
window.onscroll = magic;